import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './LeaderScore.module.scss'

const ICONS_SIZES = {
  small: '16',
  medium: '16',
  large: '24',
}

const TYPOGRAPHY_SIZES = {
  small: 'tight-xs',
  medium: 'tight-xs',
  large: 'body-sm',
}

/** @type {import("./types").default} */
const LeaderScore = ({ className, score, size = 'small' }) => {
  return (
    <div className={clsx('LeaderScore', classes.root, className)}>
      <Icon className={classes.icon} icon={['fal', 'gem']} size={ICONS_SIZES[size]} />
      <Typography variant={TYPOGRAPHY_SIZES[size]}>
        <span className={classes.ratingNumber}>{score}</span>
        pts
      </Typography>
    </div>
  )
}

export default LeaderScore
